import { Notification } from './notification.model';

export class Notifications {
  totalNotifications: number;
  totalUnreadNotifications: number;
  notifications: Notification[];
}
